module.exports = __webpack_public_path__ + "img/Monte_Kope_37.7318644c.jpg";